module.exports = __webpack_public_path__ + "static/scale-model-of-buffalo-naval-&-military-park-in-buffalo-new-york-606d8473699c20513f5c462030099196.png";